import React, { useState, useEffect } from "react";
import { Card, Col, CardBody, FormGroup, Label, Input } from "reactstrap";
import api from "../../api";

export default function EpoTotals({ lineItems = [], totals = {}, onTotalsChange }) {


    const [miles, setMiles] = useState(0);
    const [shipping, setShipping] = useState(0);
    // Batch F — mileage rate is admin-configured (EpoConfig "MILEAGE_RATE"),
    // no longer hardcoded. Default to 0.70 only until the fetch resolves.
    const [mileageRate, setMileageRate] = useState(0.7);
    const mileageAllowance = miles * mileageRate;
    const [subTotal, setSubTotal] = useState(0);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        let cancelled = false;
        api.get("Epo/mileage-rate")
            .then((res) => { if (!cancelled) { const r = Number(res?.data?.rate); if (Number.isFinite(r) && r >= 0) setMileageRate(r); } })
            .catch(() => { /* keep default on failure */ });
        return () => { cancelled = true; };
    }, []);

    useEffect(() => {
        setMiles(totals.milesTraveled || 0);
        setShipping(totals.shippingCharges || 0);
    }, [totals.milesTraveled, totals.shippingCharges]);

    useEffect(() => {
        const sum = Array.isArray(lineItems)
            ? lineItems.reduce((acc, l) => acc + parseFloat(l.extendedCost || 0), 0)
            : 0;
        setSubTotal(sum);
    }, [lineItems]);

    useEffect(() => {
        const mileageAllowance = miles * mileageRate;
        const grandTotal = subTotal + mileageAllowance + parseFloat(shipping || 0);
        setTotal(grandTotal);

        // ✅ send totals back to parent
        onTotalsChange?.({
            milesTraveled: miles,
            mileageRate,
            shippingCharges: shipping,
            approxTotal: grandTotal,
            subTotal: subTotal,
        });
    }, [miles, shipping, subTotal, mileageRate, onTotalsChange]);

    return (


        <Card className="mt-4 shadow-sm">
            <CardBody>
                <div className="d-flex flex-column gap-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="fs-14 text-primary mb-0">
                            <i className="ri-shopping-cart-fill align-middle me-2"></i>{" "}
                            Total EPO Amount
                        </h5>
                        <span className="badge bg-danger rounded-pill">

                        </span>
                    </div>
                    <FormGroup>
                        <Label className="fw-bold mb-1">Miles Traveled</Label>
                        <Input
                            type="number"
                            value={miles}
                            onChange={(e) => setMiles(Number(e.target.value))}
                            placeholder="Enter miles"
                        />
                        <small className="text-muted">
                            @ ${mileageRate.toFixed(2)}/mile = ${mileageAllowance}
                        </small>
                    </FormGroup>

                    <FormGroup>
                        <Label className="fw-bold mb-1">Shipping Charges</Label>
                        <Input
                            type="number"
                            value={shipping}
                            onChange={(e) => setShipping(Number(e.target.value))}
                            placeholder="Enter shipping charge"
                        />
                    </FormGroup>

                    <hr />

                    <div className="d-flex flex-column">
                        <div className="d-flex justify-content-between mb-1">
                            <span>Sub Total:</span>
                            <span className="fw-bold">${subTotal.toFixed(2)}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                            <span>Mileage Allowance:</span>
                            <span className="fw-bold">${mileageAllowance}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                            <span>Shipping Charge:</span>
                            <span className="fw-bold">${Number(shipping).toFixed(2)}</span>
                        </div>
                        <hr />
                        <div className="d-flex justify-content-between">
                            <strong>Grand Total:</strong>
                            <strong>${total.toFixed(2)}</strong>
                        </div>
                    </div>
                </div>
            </CardBody>
        </Card>

    );
}
